// Tiny shared form controls used by the configurator (Material / Adhesive /
// Shape / Size dropdowns and the custom dimension number inputs).  These
// were inlined in ProductDetailPage.jsx until the file decomposition.
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { productImage } from "../lib/api";

export function SelectRow({ label, value, onChange, options, testid }) {
  // Find the currently selected option so we can show its swatch inline.
  const selected = options.find((o) => o.value === value);
  return (
    <div>
      <div className="text-xs font-bold uppercase tracking-wider text-slate-600 mb-1.5 flex items-center gap-2">
        {label}
        {selected?.image && (
          <img src={productImage(selected.image)} alt="" className="w-5 h-5 object-cover border border-slate-300" data-testid={`${testid}-current-swatch`} />
        )}
      </div>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="rounded-sm h-11 border-slate-300" data-testid={testid}>
          <SelectValue placeholder={`Select ${String(label || "option").toLowerCase()}`} />
        </SelectTrigger>
        <SelectContent className="rounded-sm max-h-72">
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value} className="rounded-sm">
              <div className="flex items-center gap-2">
                {o.image && (
                  <img src={productImage(o.image)} alt="" className="w-5 h-5 object-cover border border-slate-200 flex-shrink-0" />
                )}
                <span>{o.label}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export function DimInput({ label, value, onChange, cd, axis, testid }) {
  // axis: "width" → min/max_width  · "height" → min/max_height
  // Falls back to the legacy single min_in/max_in envelope so older
  // products configured before the per-axis schema still validate.
  const fallbackMin = cd?.min_in ?? 0.5;
  const fallbackMax = cd?.max_in ?? 8.0;
  const min = (axis === "width" ? cd?.min_width : cd?.min_height) ?? fallbackMin;
  const max = (axis === "width" ? cd?.max_width : cd?.max_height) ?? fallbackMax;
  return (
    <div>
      <div className="text-xs font-bold uppercase tracking-wider text-slate-600 mb-1.5">{label}</div>
      <input
        type="number"
        step="0.125"
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="input-base h-11"
        placeholder={`${min}" – ${max}"`}
        data-testid={testid}
      />
    </div>
  );
}
